module.exports = __webpack_public_path__ + "static/img/logo1_white.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1_white.png
// module id = F3iA
// module chunks = 0